<template>
  <div
    :class="['file-message-container']"
    :title="TUITranslateService.t('TUIChat.单击下载')"
    @click="download"
  >
    <Icon
      :file="files"
      class="file-icon"
    />
    <div>
      <div>{{ props.content.name }}</div>
      <div>{{ props.content.size }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import vue from '../../../../adapter-vue';
import { TUITranslateService, IMessageModel } from '../../../../@aidesk/uikit-engine';
import Icon from '../../../common/Icon.vue';
import files from '../../../../assets/files.svg';
import { isUniFrameWork } from '../../../../utils/env';
import type { IFileMessageContent } from '../../../../interface';
const __sfc_main = {};
__sfc_main.props = {
  content: {
    key: "content",
    required: false,
    type: null,
    default: () => ({}) as IFileMessageContent
  },
  messageItem: {
    key: "messageItem",
    required: false,
    type: null,
    default: () => ({}) as IMessageModel
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    withDefaults
  } = vue;
  const props = __props;
  const download = () => {
    if (props.messageItem.hasRiskContent) {
      return;
    }

    // If the browser supports fetch, use blob to download, so as to avoid the browser clicking the a tag and jumping to the preview of the new page
    if (!isUniFrameWork && (window as any)?.fetch) {
      const option = {
        mode: 'cors',
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      } as RequestInit;
      fetch(props.content.url, option).then(res => res.blob()).then(blob => {
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = props.content.name;
        a.click();
      });
    }
  };
  return {
    TUITranslateService,
    files,
    props,
    download
  };
};
__sfc_main.components = Object.assign({
  Icon
}, __sfc_main.components);
export default __sfc_main;
</script>
<style lang="scss" scoped>
@import "../../style/common";
.file-message-container {
  display: flex;
  flex-direction: row;
  cursor: pointer;

  .file-icon {
    margin: auto 8px;
  }
}
</style>
